/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-ajouter': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" data-name="ico-ajouter" d="M9 0a9 9 0 109 9 9 9 0 00-9-9zm.82 13.63a.82.82 0 01-.82.82.85.85 0 01-.58-.24.83.83 0 01-.24-.58V9.82H4.37a.83.83 0 01-.58-.24.85.85 0 01-.24-.58.82.82 0 01.82-.82h3.81V4.37a.82.82 0 011.64 0v3.81h3.81a.82.82 0 110 1.64H9.82z"/>'
  }
})
